document.addEventListener('page:loaded', function() {
  console.log('page:loaded');
});

document.addEventListener('cart:open', function(){
  console.log('cart:open');
});
document.addEventListener('cart:close', function(){
  console.log('cart:close');
});
jQuery(document).ready(function($){
  $('#add-to-cart-button').click(function(){    
    console.log('clicked!');
    addItemToCart( 7906234138843, 1);    // paste your id product number
  });

  $('.product-suggestions__info .btn').click(function(){    
    var data_id = $(this).data('id');
    console.log('clicked!');
    addItemToCart( data_id, 1);    // paste your id product number
  });

  $('.buy_buttons, .qty_block').wrapAll('<div class="wrapped_block"></div>');
  function addItemToCart(variant_id, qty) {
    data = {
      "id": variant_id,
      "quantity": qty
    }
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        document.dispatchEvent(new CustomEvent('cart:build'));
        $('#productSuggestions').removeClass('opened');
      }
    });
  }

  $('.js-drawer-open-cart').bind('click', function(e){
    e.preventDefault();
    $('#productSuggestions').addClass('opened');
  })
  $('.drawer__close-button').bind('click', function(e){
    e.preventDefault();
    $('.last-purchased').addClass('last-purchased__show');
    $('#productSuggestions').removeClass('opened');
  })
  $('#productSuggestions').on('click',function(e){
    $(this).removeClass('opened');
  })

  $('.last-purchased__close').on('click', function(e){
    e.preventDefault();
    $(this).parent().removeClass('last-purchased__show');
  })

  $('body').on('click', '.soldout', function(e){
    e.preventDefault();
    $('#SoldOutPopup').addClass('modal--is-active');
  })
  $('body #SoldOutPopup').on('click', '.modal__close, .newsletter-button', function(e){
    e.preventDefault();
    $('#SoldOutPopup').removeClass('modal--is-active');
  })
   setTimeout(function(){ 
    $('body').find('.globo-form-app form > p').remove();
  }, 500);

  /* Off Sale Popup */
   //check to see if the submited cookie is set, if not check if the popup has been closed, if not then display the popup
  // if( getCookie('popupCookie') != 'submited'){ 
  //   if(getCookie('popupCookie') != 'closed' ){
  //     $('#off-sale').css("display", "flex").hide().fadeIn();
  //   }
  // }
  
  // $('#off-sale a.close').click(function(){
  //   $('#off-sale').fadeOut();
  //   //sets the coookie to one minute if the popup is closed (whole numbers = days)
  //   setCookie( 'popupCookie', 'closed', 1 );
  // });
  
  // $('#off-sale a.submit').click(function(){
  //   $('#off-sale').fadeOut();
  //   //sets the coookie to five minutes if the popup is submited (whole numbers = days)
  //   setCookie( 'popupCookie', 'submited', 1 );
  // });

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
})
          